/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pesticide_NameInputs */

const vi_pesticide_name = /** @type {(inputs: Pesticide_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên thuốc`)
};

/**

* @param {Pesticide_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pesticide_name = /** @type {((inputs?: Pesticide_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pesticide_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pesticide_name(inputs)
});